import React from 'react';
type SectionHeadingProps = {
  kicker?: string;
  title: React.ReactNode;
  lead?: React.ReactNode;
  align?: 'center' | 'left';
};
export function SectionHeading({
  kicker,
  title,
  lead,
  align = 'center'
}: SectionHeadingProps) {
  const alignment = align === 'center' ? 'mx-auto text-center' : 'text-left';
  return <div className={`max-w-3xl ${alignment}`} data-id="element-58" data-mp="3k0ygk7oih18p">
      {kicker && <p className="mb-3 font-display text-lg font-bold uppercase tracking-[0.08em] text-volt sm:text-xl" data-id="element-59" data-mp="bjtw9t0qii0j">
          {kicker}
        </p>}
      <h2 className="text-balance font-display text-[40px] font-extrabold uppercase leading-[0.95] text-white sm:text-6xl" data-id="element-60" data-mp="giwyz6t8sc5c">
        {title}
      </h2>
      {lead && <p className="mt-5 text-pretty text-lg leading-relaxed text-mist" data-id="element-61" data-mp="6svdmms9x7u4">{lead}</p>}
    </div>;
}